import { useLazyQuery } from "@apollo/client";
import React, { useContext, useEffect, useMemo, useState } from "react";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { FETCH_MORE_DATA, ROWS_PER_PAGE } from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import useLabels from "../../../../../customHooks/useLabels";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";

import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
  GetSuppliersResult,
  GetSuppliersVars,
  LdgrQueryType,
} from "../../masters/supplier/queries/types";
import { GetSuppliers } from "../../masters/supplier/queries/queries";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../../context/context";
import { empType } from "../../../../../utils/Enum.types";
export const enum VendorListPageFor {
  SIGNAL_WISE = "SIGNAL",
  VENDOR_WISE = "VENDOR",
}
interface Props {
  pageType: VendorListPageFor;
}
const List = ({ pageType }: Props) => {
  const { customer_id, company_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState<AtsAcLdgrEdge[]>([]);
  const [activeItemId, setActiveItemId] = useState(0);

  const { state } = useContext(AppContext);

  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [GetSupplierDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetSuppliersResult,
    GetSuppliersVars
  >(GetSuppliers);
  useEffect(() => {
    if (customer_id) {
      GetSupplierDetails({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsAcLdgrOrderField.CREATED_AT,
          },

          name: searchData,
          input: {
            query_type: LdgrQueryType.ALL,
            itemID: 0,
            tableLevel: undefined,
          },
        },
      });
    }
  }, [customer_id, GetSuppliers, searchData]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSuppliers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = suppliers.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSuppliers(updatedNewData);
      } else {
        setSuppliers(newData);
      }
      setEndCursor(data.GetSuppliers.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSuppliers.edges;
              const pageInfo = fetchMoreResult.GetSuppliers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSuppliers.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSuppliers: {
                  edges: [...suppliers, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSuppliers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [suppliers]);

  const rows1: GridValidRowModel[] = useMemo(() => {
    return suppliers.map(({ node: data }, index) => {
      return {
        id: index + 1,
        description: data.desc,
        supplierId: data.id,
      };
    });
  }, [suppliers]);
  const { ledgerLabel } = useLabels();
  const columns: GridColDef[] = [
    {
      headerName: ledgerLabel,
      cellClassName: "td-link",
      field: "description",
      headerAlign: HEADER_TEXT_ALIGN,
      flex: FlexForColumns.DESCRIPTION,
      hideable: false,
    },
  ];
  useEffect(() => {
    if (suppliers.length) {
      setActiveItemId(suppliers[0].node.id);
    }
  }, [suppliers]);
  const dashboard =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;
  return (
    <>
      <div className="asset-reports__left--list">
        {suppliers.length ? (
          <StyledDatagrid
            getCellClassName={(params) =>
              params.row.supplierId === activeItemId ? "active" : ""
            }
            columns={columns}
            rows={rows1}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            onRowClick={(params) => {
              // dispatch({
              //   type: mapsPayloadType.SUPPLIER_ID,
              //   payload: {
              //     supplierId: params.row.supplierId,
              //   },
              // });
              let basePath = "";
              if (dashboard) basePath = `/${customer_id}/reports`;
              else basePath = `/${customer_id}/company/${company_id}/reports`;
              const targetPath =
                pageType === VendorListPageFor.VENDOR_WISE
                  ? `${basePath}/vendorwise/${params.row.supplierId}`
                  : `${basePath}/signalwise/${params.row.supplierId}`;
              navigate(targetPath);

              setActiveItemId(params.row.supplierId);
            }}
          />
        ) : (
          <>
            <b className="nodata"> No data found</b>
          </>
        )}
      </div>
    </>
  );
};

export default List;
